import ApiService from "@/services/api.service";

const USER_TYPE = {
  dealer: "dealer",
  employee: "employee",
};

async function getProfile() {
  const response = await ApiService.get("/profile");

  return response.data;
}

async function updateProfile(data) {
  const response = await ApiService.patch("/profile", data, {
    withNotify: true,
  });

  return response.data;
}

async function setVideoClosed(data) {
  return ApiService.post("/events/video-closed", data);
}

async function wizardViewed(data) {
  return ApiService.post("/events/wizard-viewed", data);
}

async function publicOfferAcknowledged() {
  return ApiService.post("/events/public-offer-acknowledged");
}

async function surveyInteracted({ surveyId, action }) {
  return ApiService.post("/events/survey-interacted", {
    surveyId,
    action,
  });
}

export {
  USER_TYPE,
  getProfile,
  updateProfile,
  setVideoClosed,
  wizardViewed,
  publicOfferAcknowledged,
  surveyInteracted,
};
